import React,{Fragment} from "react";
import schedule_icon from "../../assets/media/token_earning/wall-clock.png";
import moment from "moment";
const CompetitionDetail = ({post,users, brand_name, onPostNow})=>{
      function getPostingTime(post){
        if(post.postNow){
          const date = moment.unix(post.timestamp.seconds);
          return date.format('LLL');
        }else{
          const date = moment(post.scheduledDate);
          return date.format('LLL');
        }
      };
      function isPostLive(post){
        if(post.postNow){
          return true;
        }else{
          const date = moment(post.scheduledDate);
          if(moment().isAfter(date))
            return true;
          else
            return false;
        }
      }
      function getPostedBy(post){
        const user = users.find((item) => item.id === post.uid);
        if (user) {
          return `${user.firstname} ${user.lastname || ""}`;
        }
    
        return "Unknown";
      };

      function getStatusText(){
        return post.postNow?"Live":"Pending";
      }
    return (
        <Fragment>
            <div className="details">
                <p className="time">{isPostLive(post)?"Posted at ":"Scheduled at "}{getPostingTime(post)}</p>
                <p>
                  Posted By{" "}
                  {post.from_admin ? brand_name : getPostedBy(post)}
                </p>
                <Fragment>
                    <p
                        className={`accept-status ${getStatusText()}`}
                    >
                        {getStatusText()}
                        {!isPostLive(post)&&<img src={schedule_icon} width="20" height="20" style={{marginLeft:10}}/>}
                    </p>
                </Fragment>
            </div>
            <div>
                <p className="title">{post.title}</p>
                <p className="sub-title">{post.content}</p>
                <p className="sub-title">
                  <b>Task:</b> {post.task}
                </p>
                {!post.postNow && post.scheduledDate && (
                  <p className="sub-title">
                    <b>Scheduled Date:</b>{" "}
                    {moment(post.scheduledDate).format('LLL')}
                  </p>
                )}
                {post.runUntil && (
                  <p className="sub-title">
                    <b>Run Until:</b>{" "}
                    {moment(post.runUntil).format('LLL')}
                  </p>
                )}
              </div>
        </Fragment>
        );
}
export default CompetitionDetail;


// WEBPACK FOOTER //
// ./src/screens/Competitions/CompetitionDetail.js